module.exports = __webpack_public_path__ + "img/lb.2d6fb85c.svg";